<template>
  <section class="store-viewer">
    <el-dialog
      class="store-viewer__modal"
      ref="dialog"
      title="Ambition Frontend API"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :fullscreen="true"
      :close-on-click-modal="false"
    >
      <!-- Toolbar -->
      <!-- <Toolbar /> -->
      <div class="store-viewer__toolbar px-4 py-3 border-bottom d-flex justify-content-between">
        <!-- <el-page-header content="detail" class>Hello...</el-page-header> -->

        <!-- Left -->
        <el-row type="flex" justify="start" :gutter="20">
          <el-col class="w-auto">
            <label class="mr-1">Model:</label>
            <!-- <slot name="prefix">Model</slot> -->
            <el-select
              v-model="selectedModel"
              :multiple="false"
              filterable
              remote
              reserve-keyword
              placeholder="Search..."
              size-OFF="small"
              :remote-method="searchModels"
              :loading="loading"
              :clearable="true"
              autocomplete="off"
              @change="handleModelChange"
            >
              <el-option
                v-for="item in modelNames"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- {{filters}} -->
            <!-- {{selectedModel}} -->
          </el-col>

          <el-col class="w-auto">
            <label class="mr-1">Route:</label>
            <el-select
              v-model="selectedRoute"
              :multiple="false"
              filterable
              remote
              reserve-keyword
              placeholder="Search..."
              size-OFF="small"
              :loading="loading"
              :clearable="true"
              autocomplete="off"
              :style="{ minWidth: '420px' }"
            >
              <el-option
                v-for="(item, i) in routeUrls"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>

            <!-- <el-input placeholder="Please input" class="input-with-select">
              <el-select slot="append" placeholder="Select">
                <el-option label="Restaurant" value="1"></el-option>
                <el-option label="Order No." value="2"></el-option>
                <el-option label="Tel" value="3"></el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-search"></el-button>
            </el-input>-->

            <!-- Api Version -->
            <!-- <el-select
              v-model="selectedRouteVersion"
              :multiple="false"
              filterable
              remote
              reserve-keyword
              placeholder="Api Version"
              :clearable="true"
              autocomplete="off"
              :style="{ maxWidth: 130 }"
            >
              <el-option
                v-for="(item, i) in routeVersions"
                :key="i"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>-->
          </el-col>
        </el-row>

        <!-- Right -->
        <el-row v-if="true" type="flex" justify="start" align="middle" :gutter="20">
          <el-col class="w-auto">
            <label class="mr-1">Test Mode:</label>
            <el-radio-group v-model="switchMode" size="mini">
              <el-radio-button label="Model"></el-radio-button>
              <el-radio-button label="Route"></el-radio-button>
              <!-- <el-radio-button label="Api v4"></el-radio-button> -->
            </el-radio-group>

            <!-- <el-button type="primary" icon="el-icon-setting" plain circle class="ml-2"></el-button> -->
          </el-col>
        </el-row>
      </div>

      <!-- Content -->
      <section class="p-4" :style="{ height: heights.calculated.content }">
        <el-row :gutter="24">
          <!-- Code Editor -->
          <el-col :span="14">
            <div v-if="showTreeEditor" class="tree-view border p-2 background-light">
              <el-tree :data="treeViewCode" :props="{}" :style="{ background: 'transparent' }"></el-tree>
            </div>

            <!-- Generator Code Editor -->
            <!-- <div v-if="routeCode" class="border p-2 background-light mb-3">
              <prism-editor
                v-model="routeCode"
                language="js"
                :lineNumbers="true"
                :readonly="true"
                :style="{ height: 'inherit' }"
              ></prism-editor>
            </div>-->

            <!-- Code Editor -->
            <div
              v-if="showCodeEditor"
              class="p-1-OFF border-OFF background-lighter-OFF"
              :style="{ height: '100%' }"
            >
              <prism-editor
                ref="codeEditor"
                v-model="editorCode"
                language="js"
                :lineNumbers="true"
                :style="{ height: 'inherit' }"
              ></prism-editor>
              <!-- <prism-editor
                v-if="switchMode === 'Model'"
                ref="codeEditor"
                v-model="modelCode"
                language="js"
                :lineNumbers="true"
                :style="{ height: 'inherit' }"
              ></prism-editor>
              <prism-editor
                v-else
                ref="codeEditor"
                :code="routeCode"
                language="js"
                :lineNumbers="true"
                :style="{ height: 'inherit' }"
              ></prism-editor>-->
            </div>
          </el-col>
          <!-- /Code Editor -->

          <!-- Sidebar -->
          <el-col :span="10">
            <div
              class="border p-3 background-light-OFF"
              :style="{ height: '100%', overflowY: 'scroll' }"
            >
              <!-- Sidebar Box: Route Information -->
              <div v-if="switchMode === 'Route'" class="border p-3 background-lighter-OFF mb-3">
                <!-- Route Information -->
                <div>
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h4>Route Information</h4>
                    <el-tag
                      type="success"
                      effect="plain"
                      size="small"
                      :style="{ opacity: selectedRouteVersion ? 1 : 0 }"
                    >{{selectedRouteVersion}}</el-tag>
                  </div>
                  <hr />
                  <div v-if="selectedRouteMeta">
                    <el-row
                      v-for="(e, i) in selectedRouteMeta"
                      :key="i"
                      class="mt-2"
                      type="flex"
                      align="middle"
                    >
                      <el-col :span="6" class="text-left">
                        <b>{{Ambition.Helpers.titleCase(i)}}:</b>
                      </el-col>
                      <el-col :span="18">
                        <div
                          class="ml-2 p-2 border rounded background-lighter"
                          :style="{ fontSize: '0.70rem' }"
                        >{{ Array.isArray(e) ? e.join(', ') : e }}</div>
                      </el-col>
                    </el-row>
                  </div>
                  <div v-else>No route data.</div>
                  <!-- {{selectedRoute}} -->
                </div>
              </div>

              <!-- Sidebar Box: Route Tester -->
              <div v-if="switchMode === 'Route'" class="border p-3 background-lighter-OFF mb-3">
                <section class="d-flex justify-content-between align-items-center">
                  <h4>Route Tester</h4>
                  <!-- <el-tag
                      type="success"
                      effect="plain"
                      size="small"
                      :style="{ opacity: true ? 1 : 0 }"
                  >PUT</el-tag>-->

                  <el-dropdown
                    :style="{ opacity: selectedRouteMeta ? 1 : 0 }"
                    @command="setRouteMethod"
                    trigger="click"
                  >
                    <span class="el-dropdown-link">
                      <el-tag
                        type="success"
                        effect="plain"
                        size="medium"
                        :style="{ opacity: true ? 1 : 0 }"
                      >
                        <span class="ml-0">{{ selectedRouteMethod }}</span>
                        <i class="ml-1 el-icon-arrow-down"></i>
                      </el-tag>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="e in selectedRouteMethods"
                        :key="e.label"
                        :command="e.label"
                        :disabled="e.disabled"
                      >{{e.label}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </section>

                <hr />

                <section>
                  <div v-if="selectedRouteMeta && selectedRouteMeta.parameters.length > 0">
                    <!-- Tools -->
                    <div class="d-flex justify-content-between align-items-center mb-3">
                      <el-checkbox-group
                        v-model="routeToggles"
                        :disabled="switchMode === 'Model'"
                        size="mini"
                      >
                        <el-checkbox
                          v-for="e in routeAvailableToggles"
                          :key="e.label"
                          :label="e.label"
                          :disabled="e.disabled"
                          border
                          size="small"
                        ></el-checkbox>
                      </el-checkbox-group>
                    </div>
                    <!-- <hr /> -->
                    <el-row
                      v-for="(e, i) in selectedRouteMeta.parameters"
                      :key="i"
                      type-OFF="flex"
                      align="middle"
                      class="mt-3"
                    >
                      <el-col :span="24" class="text-left mb-1">
                        <small class="font-weight-bold-OFF">{{ `\{${e}\}` }}</small>
                      </el-col>
                      <el-col :span="24">
                        <el-input
                          v-model="routeParameters[e]"
                          :placeholder="''"
                          :style="{ fontSize: '0.75rem' }"
                        >
                          <!-- <template slot="prepend">
                          <div :style="{ minWidth: '0' }">{{ `\{${e}\}` }}</div>
                          </template>-->
                        </el-input>
                      </el-col>
                    </el-row>

                    <el-row class="mt-3">
                      <el-button size="small" :disabled="!isRouteParametersFilled">Send</el-button>
                    </el-row>
                  </div>
                  <div v-else>No route parameters.</div>
                </section>
                <!-- {{selectedRoute}} -->
              </div>

              <!-- Sidebar Box: Model Tester -->
              <div v-if="switchMode === 'Model'" class="border p-3 background-lighter-OFF mb-0">
                <section class="d-flex justify-content-between align-items-center">
                  <h4>Model Tester</h4>
                  <el-tag
                    type="success"
                    effect="plain"
                    size="medium"
                    :style="{ opacity: selectedModel ? 1 : 0 }"
                  >{{selectedModel}}</el-tag>
                </section>

                <hr />

                <section>
                  <!-- Tools -->
                  <div class="d-flex justify-content-between align-items-center mb-0">
                    <!-- <el-checkbox-group
                      v-model="routeToggles"
                      :disabled="switchMode === 'Model'"
                      size="mini"
                    >
                      <el-checkbox
                        v-for="e in routeAvailableToggles"
                        :key="e.label"
                        :label="e.label"
                        :disabled="e.disabled"
                        border
                        size="small"
                      ></el-checkbox>
                    </el-checkbox-group>-->
                  </div>
                  <!-- <hr /> -->
                  <div v-if="selectedModel">
                    <!-- Model: {{ selectedModel }} -->
                    <!-- <el-input placeholder="Please input"></el-input> -->

                    <el-row
                      v-for="(e, i) in []"
                      :key="i"
                      type-OFF="flex"
                      align="middle"
                      class="mt-3"
                    >
                      <el-col :span="24" class="text-left mb-1">
                        <small class="font-weight-bold-OFF">{{ `\{${e}\}` }}</small>
                      </el-col>
                      <el-col :span="24">
                        <!-- <el-input
                          v-model="routeParameters[e]"
                          :placeholder="''"
                          :style="{ fontSize: '0.75rem' }"
                        >-->
                        <!-- <template slot="prepend">
                          <div :style="{ minWidth: '0' }">{{ `\{${e}\}` }}</div>
                        </template>-->
                        <!-- </el-input> -->
                      </el-col>
                    </el-row>
                  </div>
                  <div v-else>No model selected.</div>
                </section>
              </div>

              <!-- Sidebar Box: Generator Code Editor -->
              <!-- <div v-if="false" class="border p-3 background-lighter-OFF mt-3">
                <div>
                  <div class="d-flex justify-content-between align-items-center mb-3">
                    <h4>Code Generator</h4>
                    <el-button size="mini" :disabled="!selectedRouteMeta">Copy</el-button>
                  </div>
                  <hr />
                  <div v-if="selectedRouteMeta">
                    <prism-editor
                      v-model="routeCode"
                      language="js"
                      :lineNumbers="true"
                      :readonly="true"
                      :style="{ height: 'inherit' }"
                    ></prism-editor>
                  </div>
                  <div v-else>No route selected.</div>
                </div>
              </div>-->

              <!-- TESTING -->
              <!-- <div class="border p-3 background-lighter mt-3">
              <pre>{{ heights }}</pre>
              <div>Prism Height: {{ heights.calculated.content }}</div>
              </div>-->
            </div>
          </el-col>
          <!-- /Sidebar -->
        </el-row>
      </section>

      <!-- <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">Cancel</el-button> --
        <!-- <el-button type="primary" @click="dialogVisible = false">Confirm</el-button> --
        <el-button type="primary" @click="dialogVisible = false">Exit</el-button>
      </div>-->
    </el-dialog>
  </section>
</template>

<script>
import _ from 'underscore'

import PrismEditor from 'vue-prism-editor'

export default {
  components: {
    'prism-editor': PrismEditor
  },
  props: {
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,

      keyEventName: 'keydown.StoreDemoViewer.toggle',
      keyEventLogger: '',
      keyEventTimer: Moment(),
      keyEventCombo: ['Alt', 'Alt'],

      heights: { raw: {}, calculated: {} },

      editorCode: 'Hello...',
      showCodeEditor: true,
      showTreeEditor: false,

      filters: { model: null },

      modelCode: '',
      selectedModel: null,

      switchMode: 'Model',

      routeParameters: {},
      routeToggles: [],
      selectedRouteMethod: 'GET',
      selectedRoute: null,
      selectedRouteKey: 'uri' // key parameter from $store2.$data.routes[x] object

      // selectedRouteVersion: null
    }
  },
  computed: {
    urlArray() {
      if (!this.selectedRouteMeta || !this.selectedRouteMeta.uri) return '?'
      let url = this.selectedRouteMeta.uri

      url = url.replace(/}/ig, '}>>>').split('>>>')
      // add starting slash to make the output array look more uniform
      // if (url[0].substr(0) !== '/') url[0] = `/${url[0]}`
      // remove empty elements, usually the trailing '' element
      return url.filter((e) => e.length)
    },

    isRouteNamed() {
      const meta = this.selectedRouteMeta
      return meta && meta.name && meta.name.substr(-1) !== '.'
    },

    isRouteParametersFilled() {
      let isFilled = true
      let values = Object.values(this.routeParameters)

      if (values.length === 0) isFilled = false
      else values.forEach((e) => { if (e.length === 0) isFilled = false })

      return isFilled
    },

    routeCode() {
      const indent = (i = 1) => ` `.repeat(i * 2)

      const meta = this.selectedRouteMeta
      if (!meta) return '...'

      const shortenUrl = this.isRouteToggleEnabled('shortenUrl')

      let urlArray = this.urlArray.map((e, i) => {
        let isLast = (i + 1) === this.urlArray.length
        return `${indent(2)}'${e}'` + (isLast ? '' : ',')
      })

      // customise url/name route format
      let routeCode = []
      if (this.isRouteNamed) routeCode.push(`${indent(1)}name: '${meta.name}'`)
      else if (shortenUrl) routeCode = [`${indent(1)}url: [`, ...urlArray, `${indent(1)}]`]
      else routeCode.push(`${indent(1)}url: '${meta.uri}'`)

      // create a formatted string of code
      const code = [
        `$store2.request({`,
        `${indent(1)}method: '${this.selectedRouteMethod}',`,
        ...routeCode,
        meta.parameters.length ? `}, {` : '',
        ...meta.parameters.map((e, i) => {
          let isLast = (i + 1) === meta.parameters.length
          let parameter = this.routeParameters[e]

          // if parameter is numeric, don't wrap it in quotes
          if (!parameter) parameter = ''
          else if (parameter.match(/^[0-9]+$/i)) parameter = `: ${parameter}`
          else parameter = `: "${parameter}"`

          return `${indent(1)}${e}` + parameter + (isLast ? '' : ',')
        }),
        `}).then((response) => {`,
        `${indent(1)}// handle successful response`,
        `}).catch((error) => {`,
        `${indent(1)}// handle error response`,
        `})`
      ].filter((e) => e.length > 0)
      // console.warn('CODE', code)

      return code.join('\n')
    },

    treeViewCode() {
      if (!this.showTreeEditor) return false
      try {
        const modelCode = JSON.parse(this.modelCode)
        // console.warn('treeViewCode: modelCode', modelCode)
        const treeCode = Object.entries(modelCode).map((e) => {
          const label = e[0], value = e[1]
          const children = typeof value !== 'object' ? [] : Object.keys(value).map((e) => ({ label: e, children: [] }))
          return { label, children }
        })
        // console.warn('treeViewCode: treeCode', treeCode)
        return treeCode
      } catch (e) {
      }
      return [
        // { label: 'Level one 1', children: [{ label: 'Level two 1-1', children: [{ label: 'Level three 1-1-1' }] }] },
        // { label: 'Level one 2', children: [{ label: 'Level two 2-1', children: [{ label: 'Level three 2-1-1' }] }] },
        // { label: 'Level one 3', children: [{ label: 'Level two 3-1', children: [{ label: 'Level three 3-1-1' }] }] },
      ]
    },

    routeAvailableToggles() {
      return {
        shortenUrl: { label: 'Split Route URL', disabled: this.isRouteNamed || this.switchMode !== 'Route' }
      }
    },

    selectedRouteMeta() {
      const meta = Object.values($store2.$data.routes).find((e) => {
        const matchKey = e[this.selectedRouteKey] === this.selectedRoute
        // optional, set to null and ignored when route changes
        const matchMethod = this.selectedRouteMethod === null ? true : e['methods'].includes(this.selectedRouteMethod)
        return matchKey && matchMethod
      })

      const method = meta && meta.methods.length > 0 ? meta.methods[0] : null
      if (this.selectedRouteMethod === null) this.setRouteMethod(method)

      // console.warn('selectedRouteMeta()', meta)
      return meta
    },

    selectedRouteVersion() {
      const meta = this.selectedRouteMeta
      if (meta && meta.uri) {
        const match = new RegExp(/api\/(v[0-9])/ig).exec(meta.uri)
        const version = match ? match[1] : null
        if (version) return version
      }
      return null
    },

    selectedRouteMethods() {
      if (!this.selectedRouteMeta) return []
      const { methods } = this.selectedRouteMeta
      if (!methods || !Array.isArray(methods)) return []
      // console.warn('selectedRouteMethods()', methods)
      // const excludes = ['HEAD']

      // New Method
      const groupedMethods = this.selectedGroupedRouteMethods
      // console.warn('selectedGroupedRouteMethods()', groupedMethods)
      // this.selectedRouteMethod = groupedMethods[0]
      return groupedMethods.map((e) => {
        return { label: e, disabled: false }
      })

      // Old Method
      // this.selectedRouteMethod = methods[0]
      // // return methods.filter((e) => excludes.includes(3))
      // return ['GET', 'POST', 'PUT', 'PATCH', 'DELETE'].map((e) => {
      //   return { label: e, disabled: !methods.includes(e) }
      // })
    },

    selectedGroupedRouteMethods() {
      const meta = this.selectedRouteMeta
      if (meta && meta.uri) {
        return _.chain(this.groupedRoutes[meta.uri]).pluck('methods').flatten().uniq().value()
      }
      return null
    },

    routeVersions() {
      return ['v1', 'v2', 'v3', 'v4'].map(((e) => ({ value: e, label: e })))
    },

    groupedRoutes() {
      const routes = _.groupBy($store2.$data.routes, (e) => e.uri)
      // console.warn('groupedRoutes()', routes)
      return routes
    },

    routeUrls() {
      const urls = []
      Object.values($store2.$data.routes).forEach((e) => {
        const route = { value: e[this.selectedRouteKey], label: e.uri }
        if (urls.find((existing) => existing.label === route.label)) return false
        urls.push(route)
      })
      return urls
    },

    modelNames() {
      const { model } = this.filters

      return Object.keys($store2.models).map(((e) => ({ value: e, label: e }))).filter((e) => {
        let include = true

        if (model && model.length > 0) {
          include = e.value.toLowerCase().includes(this.filters.model.toLowerCase())
        }

        return include
      })
    }
  },
  watch: {
    switchMode: { handler: 'setEditorCode', immediate: false },
    routeParameters: { handler: 'setEditorCode', deep: true },
    routeToggles: { handler: 'setEditorCode' },
    selectedModel: { handler: 'setEditorCode' },
    // selectedRoute: ['setEditorCode'],
    selectedRoute() {
      this.setRouteMethod(null)
      this.routeParameters = {}
      this.setEditorCode()
    },
    selectedRouteMethod: { handler: 'setEditorCode' },
  },
  mounted() {
    // Only run in dev mode
    if (Ambition.isDev()) $(window).bind(this.keyEventName, this.checkMagicKeys)

    $(this.$refs.dialog.$el).ready(() => {
      this.calculateHeights()
      this.editorCode = '...'
    })
  },
  updated() {
  },
  activated() {
    // this.calculateHeights()
  },
  beforeDestroy() {
    $(window).unbind(this.keyEventName)
  },
  methods: {
    setRouteMethod(e = null) {
      // console.warn('setRouteMethod()', e)
      this.selectedRouteMethod = e
    },

    isRouteToggleEnabled(name) {
      const toggle = this.routeAvailableToggles[name]
      return toggle && this.routeToggles.includes(toggle.label)
    },

    setEditorCode() {
      if (this.switchMode === 'Model') return this.editorCode = this.modelCode
      if (this.switchMode === 'Route') return this.editorCode = this.routeCode
      this.editorCode = '...'
    },

    calculateHeights() {
      const $dialog = $(this.$refs.dialog.$el)
      const $header = $dialog.find('.el-dialog__header')
      const $body = $dialog.find('.el-dialog__body')
      const $toolbar = $dialog.find('.store-viewer__toolbar')

      // Raw heights
      const raw = {
        dialog: $dialog.outerHeight(),
        header: $header.outerHeight(),
        body: $body.outerHeight(),
        toolbar: $toolbar.outerHeight()
      }

      // Calculted heights
      const { dialog, header, toolbar } = raw
      const calculated = {
        content: `${dialog - header - toolbar}px`
      }

      this.heights = { raw, calculated }
    },

    searchModels(query) {
      // this.loading = true
      // setTimeout(() => { this.loading = false }, 1500)
      this.filters.model = query
    },

    clearFilters() {
      this.filters.model = null
    },

    handleModelChange() {
      this.clearFilters()

      let code = ''
      let name = this.selectedModel
      let model = $store2.models[name]

      if (model) code = JSON.stringify(model, null, 4)

      this.modelCode = code

      // this.code = `const a = [1, 2, 3]\n`
      // console.warn('PRISM', this.$refs.codeEditor)
      // this.$refs.codeEditor.$el.highlightAll()
    },

    handleClose(done) {
      // this.$confirm('Are you sure to close this dialog?')
      //   .then(() => { done() })
      //   .catch(() => { })
      done()
    },

    toggleModal(open) {
      this.dialogVisible = typeof open === 'boolean' ? open : !this.dialogVisible
      // if (this.dialogVisible) {
      //   this.calculateHeights()
      // } else {
      // }
    },

    // Handle key combos to open modal
    checkMagicKeys(e) {
      const timeSinceLastEvent = Moment().diff(this.keyEventTimer, 'seconds')
      // console.warn('StoreDemoViewer', { key: e.key, log: this.keyEventLogger, timeSinceLastEvent })

      // Check last log time and clear log if time exceeds X
      if (timeSinceLastEvent > 1) this.keyEventLogger = ''

      // Add keypress to the logger
      this.keyEventTimer = Moment()
      this.keyEventLogger += `${e.key}`

      const isComboPressed = this.keyEventLogger.includes(this.keyEventCombo.join(''))

      if (isComboPressed) {
        this.keyEventLogger = ''
        this.toggleModal()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// @import '@assets/sass/backend/_core-variables.scss';

pre {
  margin: 0;
}

.store-viewer__toolbar {
}

.el-select-dropdown__item.font-monospace {
  font-family: monospace !important;
}
</style>

<style lang="scss">
.store-viewer {
  $color-dark: #222;
  $color-light: #eee;
  // $color-lighter: lighten($color-light, 5%);
  // $color-lighter: rgba($color-light, 0.5);
  // $color-lighter: lighten(#F3F3F3, 3%);
  $color-lighter: #dfe2e552;

  .background-white {
    background-color: #fff;
  }
  .background-light {
    background-color: $color-light;
  }
  .background-lighter {
    background-color: $color-lighter;
  }

  // Tree
  .el-tree-node__expand-icon::before {
    // color: $color-dark;
  }

  // Modal
  .store-viewer__modal.el-dialog__wrapper {
    margin: 30px;
    .el-dialog {
      min-width: 95%;
      &.is-fullscreen {
      }
    }
    .el-dialog__header {
      padding: 15px 24px;
      border-bottom: 1px solid #dcdfe6;
    }
    .el-dialog__body {
      padding: 0;
    }
  }

  // Radios
  label.el-radio-button {
    margin-bottom: 0;
  }

  label.el-checkbox {
    height: auto !important;
    &.el-checkbox--mini {
      $padding: 8px;
      padding: $padding ($padding + 2px);
    }
  }

  // Toolbar
  .store-viewer__toolbar {
    @extend .background-lighter;
    input {
      font-size: 0.75rem;
    }
  }

  // JS Code Editor
  .prism-editor-wrapper {
    height: 600px;
    .prism-editor__line-numbers {
      // min-height: 0 !important;
      height: auto;
      padding-bottom: 14px;
    }
  }
}
</style>
